/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SheetGenerationSettingsIndicator'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./SheetGenerationSettingsIndicator'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetGenerationSettings = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.SheetGenerationSettingsIndicator);
  }
}(this, function(ApiClient, SheetGenerationSettingsIndicator) {
  'use strict';




  /**
   * The SheetGenerationSettings model module.
   * @module model/SheetGenerationSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SheetGenerationSettings</code>.
   * @alias module:model/SheetGenerationSettings
   * @class
   */
  var exports = function() {
    var _this = this;
















  };

  /**
   * Constructs a <code>SheetGenerationSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SheetGenerationSettings} obj Optional instance to populate.
   * @return {module:model/SheetGenerationSettings} The populated <code>SheetGenerationSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('DimensionID')) {
        obj['DimensionID'] = ApiClient.convertToType(data['DimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('HistoricValuesSourceDimensionID')) {
        obj['HistoricValuesSourceDimensionID'] = ApiClient.convertToType(data['HistoricValuesSourceDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('HistoricValuesSourceYear')) {
        obj['HistoricValuesSourceYear'] = ApiClient.convertToType(data['HistoricValuesSourceYear'], 'Integer');
      }
      if (data.hasOwnProperty('IncludeHistoricValues')) {
        obj['IncludeHistoricValues'] = ApiClient.convertToType(data['IncludeHistoricValues'], 'Boolean');
      }
      if (data.hasOwnProperty('IsRolling')) {
        obj['IsRolling'] = ApiClient.convertToType(data['IsRolling'], 'Boolean');
      }
      if (data.hasOwnProperty('IsTemplate')) {
        obj['IsTemplate'] = ApiClient.convertToType(data['IsTemplate'], 'Boolean');
      }
      if (data.hasOwnProperty('Indicators')) {
        obj['Indicators'] = ApiClient.convertToType(data['Indicators'], [SheetGenerationSettingsIndicator]);
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('PeriodID')) {
        obj['PeriodID'] = ApiClient.convertToType(data['PeriodID'], 'Integer');
      }
      if (data.hasOwnProperty('RemindedUserID')) {
        obj['RemindedUserID'] = ApiClient.convertToType(data['RemindedUserID'], 'Integer');
      }
      if (data.hasOwnProperty('ReminderPeriodTypeID')) {
        obj['ReminderPeriodTypeID'] = ApiClient.convertToType(data['ReminderPeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ResponsibleUserID')) {
        obj['ResponsibleUserID'] = ApiClient.convertToType(data['ResponsibleUserID'], 'Integer');
      }
      if (data.hasOwnProperty('SendReminder')) {
        obj['SendReminder'] = ApiClient.convertToType(data['SendReminder'], 'Boolean');
      }
      if (data.hasOwnProperty('StartDate')) {
        obj['StartDate'] = ApiClient.convertToType(data['StartDate'], 'Date');
      }
      if (data.hasOwnProperty('EndDate')) {
        obj['EndDate'] = ApiClient.convertToType(data['EndDate'], 'Date');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} DimensionID
   * @default 0
   */
  exports.prototype['DimensionID'] = 0;
  /**
   * @member {Integer} HistoricValuesSourceDimensionID
   */
  exports.prototype['HistoricValuesSourceDimensionID'] = undefined;
  /**
   * @member {Integer} HistoricValuesSourceYear
   */
  exports.prototype['HistoricValuesSourceYear'] = undefined;
  /**
   * @member {Boolean} IncludeHistoricValues
   * @default false
   */
  exports.prototype['IncludeHistoricValues'] = false;
  /**
   * @member {Boolean} IsRolling
   * @default false
   */
  exports.prototype['IsRolling'] = false;
  /**
   * @member {Boolean} IsTemplate
   * @default false
   */
  exports.prototype['IsTemplate'] = false;
  /**
   * @member {Array.<module:model/SheetGenerationSettingsIndicator>} Indicators
   */
  exports.prototype['Indicators'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} PeriodID
   * @default 0
   */
  exports.prototype['PeriodID'] = 0;
  /**
   * @member {Integer} RemindedUserID
   */
  exports.prototype['RemindedUserID'] = undefined;
  /**
   * @member {Integer} ReminderPeriodTypeID
   */
  exports.prototype['ReminderPeriodTypeID'] = undefined;
  /**
   * @member {Integer} ResponsibleUserID
   * @default 0
   */
  exports.prototype['ResponsibleUserID'] = 0;
  /**
   * @member {Boolean} SendReminder
   * @default false
   */
  exports.prototype['SendReminder'] = false;
  /**
   * @member {Date} StartDate
   */
  exports.prototype['StartDate'] = undefined;
  /**
   * @member {Date} EndDate
   */
  exports.prototype['EndDate'] = undefined;



  return exports;
}));


